import * as React from "react";
import type { SVGProps } from "react";
const SvgWind03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M7.417 20.819c1.269.267 2.844.425 4.551.425 1.835 0 3.519-.183 4.833-.488M3.884 12.261c1.707.98 4.69 1.629 8.084 1.629 3.395 0 6.378-.649 8.085-1.629M5.4 16.556c1.387.608 3.81 1.01 6.568 1.01s5.182-.402 6.569-1.01M21.6 6.293c0 1.953-4.298 3.537-9.6 3.537S2.4 8.246 2.4 6.293 6.698 2.756 12 2.756s9.6 1.584 9.6 3.537Z"
    />
  </svg>
);
export default SvgWind03;
